import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const StartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-align: center;
  padding: 20px;
`;

const Title = styled(motion.h1)`
  font-size: 3.5rem;
  font-weight: bold;
  margin-bottom: 20px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
`;

const Subtitle = styled(motion.p)`
  font-size: 1.3rem;
  margin-bottom: 40px;
  opacity: 0.9;
  max-width: 500px;
  line-height: 1.6;
`;

const StartButton = styled(motion.button)`
  background: white;
  color: #667eea;
  border: none;
  border-radius: 50px;
  padding: 18px 50px;
  font-size: 1.2rem;
  font-weight: bold;
  cursor: pointer;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
  }
`;

const Instructions = styled(motion.div)`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 30px;
  margin: 40px 0;
  max-width: 600px;
  backdrop-filter: blur(10px);
`;

const InstructionTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #fff;
`;

const InstructionList = styled.ul`
  text-align: left;
  font-size: 1.1rem;
  line-height: 1.8;
  list-style: none;
  padding: 0;
`;

const InstructionItem = styled.li`
  margin: 10px 0;
  padding-left: 30px;
  position: relative;
  
  &:before {
    content: '✨';
    position: absolute;
    left: 0;
  }
`;

interface StartScreenProps {
  onStart: () => void;
}

const StartScreen: React.FC<StartScreenProps> = ({ onStart }) => {
  return (
    <StartContainer>
      <Title
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        반응속도 테스트
      </Title>
      
      <Subtitle
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        당신의 반응 속도는 얼마나 빠를까요?
      </Subtitle>

      <Instructions
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
      >
        <InstructionTitle>게임 방법</InstructionTitle>
        <InstructionList>
          <InstructionItem>시작 버튼을 누르면 게임이 시작됩니다</InstructionItem>
          <InstructionItem>화면이 주황색일 때 기다리세요</InstructionItem>
          <InstructionItem>초록색으로 바뀌면 즉시 클릭하세요</InstructionItem>
          <InstructionItem>반응 속도에 따라 점수가 부여됩니다</InstructionItem>
          <InstructionItem>최고 점수를 도전해보세요!</InstructionItem>
        </InstructionList>
      </Instructions>

      <StartButton
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.6 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={onStart}
      >
        시작
      </StartButton>
    </StartContainer>
  );
};

export default StartScreen;